/** DariusPainter — 2D axe fighter silhouette. */
import { paintFighterBuffCues } from './paintFighterBuffCues.js';

export const DariusPainter = {
  paint(ctx, _pos, radius, entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.95, 0, Math.PI * 2);
    ctx.fillStyle = '#64748b';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(radius * 0.2, -radius * 0.3);
    ctx.lineTo(radius * 1.3, 0);
    ctx.lineTo(radius * 0.2, radius * 0.3);
    ctx.closePath();
    ctx.fillStyle = '#991b1b';
    ctx.fill();
    paintFighterBuffCues(ctx, radius, entity);
  }
};
